import { render, staticRenderFns } from "./zhongzhengInfo.vue?vue&type=template&id=6c4b1a2d"
import script from "./zhongzhengInfo.vue?vue&type=script&lang=js"
export * from "./zhongzhengInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports